import React from 'react';
import Box from '@mui/material/Box';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { brand } from '../styles/maintheme';

// The wordmark spec: SemiBold, +0.02em tracking, always lowercase, with the
// two-tone split — "timing" in the surrounding text colour, ".kiwi" in Slate.
// Kept as its own component (rather than baked into the h4/h6 theme variants)
// so it doesn't leak into unrelated headings that happen to reuse those variants.
const Wordmark = ({ sx, ...props }: TypographyProps) => (
  <Typography
    {...props}
    sx={{ fontWeight: 600, letterSpacing: '0.02em', textTransform: 'lowercase', ...sx }}
  >
    timing<Box component="span" sx={{ color: brand.slate }}>.kiwi</Box>
  </Typography>
);

export default Wordmark;
